// extracted by mini-css-extract-plugin
export default {"truncateText":"boxes_truncateText__+A5iv","gridRow":"boxes_gridRow__47eCM","stripes-animation-background-keyframes":"boxes_stripes-animation-background-keyframes__Qsgoy"};